import { Box, IconButton } from '@mui/material'
import { useContext } from 'react'
import { FaTh, FaThLarge, FaThList } from 'react-icons/fa'

import { ListVariantComponentType, ListVariantContext } from '../../Contexts'

const ListVariantButton: React.FC = () => {
  const { update, componentType, size } = useContext(ListVariantContext)
  const listVariantIcon =
    componentType === ListVariantComponentType.Card ? (
      size === 'small' ? (
        <FaThLarge />
      ) : (
        <FaThList />
      )
    ) : componentType === ListVariantComponentType.Bar ? (
      <FaTh />
    ) : null

  const onClick = () => {
    if (componentType === ListVariantComponentType.Card) {
      if (size === 'small') {
        update?.(ListVariantComponentType.Card, 'medium')
      } else {
        update?.(ListVariantComponentType.Bar)
      }
    } else {
      update?.(ListVariantComponentType.Card, 'small')
    }
  }

  return (
    <Box alignItems="center" display="flex" justifyContent="center">
      {listVariantIcon ? (
        <IconButton onClick={onClick} style={{ padding: '6px' }}>
          {listVariantIcon}
        </IconButton>
      ) : null}
    </Box>
  )
}

export default ListVariantButton
